import { makeAutoObservable, runInAction } from 'mobx';
import { useEffect } from 'react';

import { shopApi, type ShopItem } from '@shared/api';

class ShopCatalog {
  items: ShopItem[] = [];
  loading = true;
  loaded = false;
  error = false;
  private loadedAt = 0;
  private request: Promise<void> | null = null;

  constructor() {
    makeAutoObservable(this, {}, { autoBind: true });
  }

  image(kind: string) {
    const candidates = this.items.filter((item) => item.kind === kind && item.imageUrl);
    return (candidates.find((item) => item.effectQty === 1) ?? candidates[0])?.imageUrl;
  }

  load(force = false): Promise<void> {
    if (this.request) return this.request;
    if (!force && this.loadedAt && Date.now() - this.loadedAt < 5 * 60_000) return Promise.resolve();
    this.loading = true;
    this.error = false;
    this.request = shopApi
      .list()
      .then(
        (items) =>
          runInAction(() => {
            this.items = items;
            this.loaded = true;
            this.loadedAt = Date.now();
          }),
        () =>
          runInAction(() => {
            this.error = true;
          }),
      )
      .finally(() =>
        runInAction(() => {
          this.loading = false;
          this.request = null;
        }),
      );
    return this.request;
  }
}

const catalog = new ShopCatalog();

export const useShopCatalog = () => {
  useEffect(() => {
    void catalog.load();
  }, []);
  return catalog;
};
